/**
 * Litvik logo palette (sampled from litvik_logo.jpg):
 * slate #305870 | primary #186098 | accent #0090D8
 */
export const LITVIK = {
  slate: '#305870',
  primary: '#186098',
  accent: '#0090D8',
  accentLight: '#40B8E8',
  accentSoft: '#5EC8F0',
  deep: '#0F3F66',
  mid: '#1A78B0',
  text: '#1A3A50',
  muted: '#5F7A8F',
};

export const LITVIK_GRADIENT = {
  header: `linear-gradient(135deg, ${LITVIK.slate} 0%, ${LITVIK.primary} 48%, ${LITVIK.accent} 100%)`,
  primary: `linear-gradient(135deg, ${LITVIK.primary} 0%, ${LITVIK.accent} 100%)`,
  badge: `linear-gradient(135deg, ${LITVIK.primary} 0%, ${LITVIK.slate} 100%)`,
  soft: `linear-gradient(135deg, #f4fafd 0%, #ffffff 55%, #eef7fc 100%)`,
};

/** Summary-card themes — all derived from Litvik blues for visual variety */
export const GRADIENT_THEMES = {
  today: {
    gradient: `linear-gradient(135deg, ${LITVIK.primary} 0%, ${LITVIK.accent} 55%, ${LITVIK.accentSoft} 100%)`,
    shadow: '0 8px 20px rgba(0, 144, 216, 0.28)',
  },
  blue: {
    gradient: `linear-gradient(135deg, ${LITVIK.slate} 0%, ${LITVIK.primary} 55%, ${LITVIK.accent} 100%)`,
    shadow: '0 8px 20px rgba(24, 96, 152, 0.24)',
  },
  teal: {
    gradient: `linear-gradient(135deg, #0E6A98 0%, ${LITVIK.accent} 55%, ${LITVIK.accentLight} 100%)`,
    shadow: '0 8px 20px rgba(0, 144, 216, 0.24)',
  },
  purple: {
    gradient: `linear-gradient(135deg, ${LITVIK.slate} 0%, #1A5080 55%, #3A98C8 100%)`,
    shadow: '0 8px 20px rgba(48, 88, 112, 0.24)',
  },
  rose: {
    gradient: `linear-gradient(135deg, #1A4A68 0%, ${LITVIK.primary} 55%, #4A9AD0 100%)`,
    shadow: '0 8px 20px rgba(24, 96, 152, 0.22)',
  },
  cyan: {
    gradient: `linear-gradient(135deg, #0E6A98 0%, ${LITVIK.accent} 55%, ${LITVIK.accentSoft} 100%)`,
    shadow: '0 8px 20px rgba(0, 144, 216, 0.22)',
  },
  gray: {
    gradient: `linear-gradient(135deg, ${LITVIK.slate} 0%, #4A6B80 55%, #7A9AAD 100%)`,
    shadow: '0 8px 20px rgba(48, 88, 112, 0.2)',
  },
};
